import { ReactNode } from 'react'
import { Sidebar } from './Sidebar'
import { NotificationBell } from '../../../modules/notifications/components'
import { useAuthStore } from '../../../modules/auth/store'

interface DesktopLayoutProps {
  children: ReactNode
  className?: string
}

export function DesktopLayout({ children, className = '' }: DesktopLayoutProps) {
  const { user, logout } = useAuthStore()

  return (
    <div className={`desktop-layout ${className}`}>
      <Sidebar userName={user?.nombre} onLogout={logout} />

      <div className="desktop-layout__main">
        <header className="desktop-layout__header">
          <div className="desktop-layout__header-content">
            <div className="desktop-layout__user-area">
              <NotificationBell />
              {user && <span className="desktop-layout__user-name">{user.nombre}</span>}
            </div>
          </div>
        </header>

        <main className="desktop-layout__content">{children}</main>
      </div>
    </div>
  )
}
